import { AiOutlineInstagram } from "react-icons/ai";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// 이미지 임포트
const images = Array.from({ length: 24 }, (_, index) => require(`../../img/sns/sns (${index + 1}).jpg`));

const AboutSNS = () => {
   // 이미지 슬라이드(자동+ 클릭)
   const [currentIndex, setCurrentIndex] = useState(0);
   const [startX, setStartX] = useState(0);
   const [isDragging, setIsDragging] = useState(false);

   useEffect(() => {
      const interval = setInterval(() => {
         if (!isDragging) {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
         }
      }, 3000); // 슬라이드 딜레이 타임

      return () => clearInterval(interval);
   }, [isDragging]);

   const handleDragStart = (e) => {
      setIsDragging(true);
      setStartX(e.clientX);
   };

   const handleDragEnd = () => {
      setIsDragging(false);
   };

   const handleDragMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - startX;
      if (deltaX > 50) {
         setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
         setIsDragging(false);
      } else if (deltaX < -50) {
         setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, images.length - 1));
         setIsDragging(false);
      }
   };

   return (
      <div id='AboutSNS'>
         <div className='inner'>
            <h1><AiOutlineInstagram />SHOP.LCDC</h1>
            <Link to='https://www.instagram.com/lcdc.seoul/' target="_blank" ><h3>더보기</h3></Link>
            <div
               className='snsBox'
               onMouseDown={handleDragStart}
               onMouseUp={handleDragEnd}
               onMouseLeave={handleDragEnd}
               onMouseMove={handleDragMove}
            >
               {images.concat(images.slice(0, 5)).map((imgUrl, index) => (
                  <img
                     key={index}
                     src={imgUrl}
                     alt='SNS이미지'
                     style={{
                        transform: `translateX(${(index - currentIndex) * 100}%)`,
                        transition: "transform 0.3s ease",
                     }}
                  />
               ))}
            </div>
         </div>
      </div>
   );
};

export default AboutSNS;
